// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1g6f4tg0 {
  background: #e1e3e5;
  top: 1px;
  left: 1px;
  position: absolute;
  z-index: 1;
  height: 34px;
  border-right: 0;
  padding: 10px 20px;
  border-top-left-radius: var(--_18w76bw4t);
  border-bottom-left-radius: var(--_18w76bw4t);
}
._1g6f4tg1 {
  border-left: 3px solid var(--_18w76bw31);
  margin: var(--_18w76bwg);
  margin-right: 0;
  padding-left: 18px;
}
._1g6f4tg2 {
  padding-top: var(--_18w76bwb);
  list-style-type: disc;
  padding-left: var(--_18w76bwg);
}
._1g6f4tg3 {
  padding-left: 125px;
  color: var(--_18w76bw2g);
  border-width: 1px;
  border-style: solid;
  border-color: var(--_18w76bw2a);
  border-top-right-radius: var(--_18w76bw4t);
  background-color: var(--_18w76bw26);
  border-bottom-right-radius: var(--_18w76bw4t);
}
._1g6f4tg3:placeholder {
  color: #d1d1d1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0CAA0C;EAC1C,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB","sourcesContent":["._1g6f4tg0 {\n  background: #e1e3e5;\n  top: 1px;\n  left: 1px;\n  position: absolute;\n  z-index: 1;\n  height: 34px;\n  border-right: 0;\n  padding: 10px 20px;\n  border-top-left-radius: var(--_18w76bw4t);\n  border-bottom-left-radius: var(--_18w76bw4t);\n}\n._1g6f4tg1 {\n  border-left: 3px solid var(--_18w76bw31);\n  margin: var(--_18w76bwg);\n  margin-right: 0;\n  padding-left: 18px;\n}\n._1g6f4tg2 {\n  padding-top: var(--_18w76bwb);\n  list-style-type: disc;\n  padding-left: var(--_18w76bwg);\n}\n._1g6f4tg3 {\n  padding-left: 125px;\n  color: var(--_18w76bw2g);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--_18w76bw2a);\n  border-top-right-radius: var(--_18w76bw4t);\n  background-color: var(--_18w76bw26);\n  border-bottom-right-radius: var(--_18w76bw4t);\n}\n._1g6f4tg3:placeholder {\n  color: #d1d1d1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
